export class DashboardPDModel {
	activeSurveys: number;
	finishedSurveys: number;
	newPeople: number;
}

export class DashboardMenuModel{
  public totalSurveys: number;
  public totalPeople: number;
  public totalUsers: number
}

export class ActionLog {
  public listActions: ListActions[];
}

export class ListActions {
  public id: number;
  public firstName: string;
  public lastName: string;
  public actionName: string;
  public dateCreated: Date;
}



// WEBPACK FOOTER //
// ./src/app/models/dashboard/dashboard.model.ts